module.exports = __webpack_public_path__ + "static/media/01-galeria-06-gucci@2x.b3bb2552.jpg";